import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-combined-dentures',
  templateUrl: './combined-dentures.component.html',
  styleUrls: ['./combined-dentures.component.scss']
})
export class CombinedDenturesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
